import * as Sentry from '@sentry/angular';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';

Sentry.init({
  dsn: 'https://b64d37f4346cc3d8bb972acd6cc70ea1@o4508374103490560.ingest.us.sentry.io/4509725617815552',
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: 1,
  enableLogs: true,
  sendDefaultPii: true,
});

bootstrapApplication(App, appConfig).catch((err) => console.error(err));
